module.exports = __webpack_public_path__ + "static/media/image-7.2816ed8a.png";